import {useCallback, useContext, useEffect, useState} from 'react'

import Context from '@s-ui/react-context'

const STORAGE_VALUE_KEY = 'leadEnrichmentValue'

const readFromStorage = key => {
  try {
    const existingData = window.localStorage.getItem(key)

    if (!existingData) {
      return null
    }

    const parsed = JSON.parse(existingData)

    return Array.isArray(parsed?.[STORAGE_VALUE_KEY]) ? parsed[STORAGE_VALUE_KEY] : null
  } catch {
    return null
  }
}

const writeToStorage = (key, value) => {
  try {
    const existingData = window.localStorage.getItem(key)
    const parsed = existingData ? JSON.parse(existingData) : {}

    window.localStorage.setItem(key, JSON.stringify({...parsed, [STORAGE_VALUE_KEY]: value}))
  } catch {}
}

export const useBuyerIntentionsStorage = ({enabled = true} = {}) => {
  const {domain} = useContext(Context)
  const {LAST_CONTACT_DETAIL_KEY} = domain.get('config').get('contact')

  const [restored, setRestored] = useState(null)

  useEffect(() => {
    if (!enabled || typeof window === 'undefined') {
      return
    }

    const stored = readFromStorage(LAST_CONTACT_DETAIL_KEY)

    if (stored?.length) {
      setRestored(stored)
    }
  }, [enabled, LAST_CONTACT_DETAIL_KEY])

  const persist = useCallback(
    value => {
      if (!enabled || typeof window === 'undefined') {
        return
      }

      writeToStorage(LAST_CONTACT_DETAIL_KEY, value)
    },
    [enabled, LAST_CONTACT_DETAIL_KEY]
  )

  return {restoredBuyerIntentions: restored, persistBuyerIntentions: persist}
}

export default useBuyerIntentionsStorage
